import { FileLayoutMaintenancePageState } from ".";

export const displayColumn = [
  { label: "Data Kind ID", value: "dtKindId" },
  { label: "Owned Component ID", value: "ownCpntId" },
];

export const FileLayoutMaintenancePageInitialState: FileLayoutMaintenancePageState =
  {
    isSaved: true,
    searchResult: {
      fileLayoutList: [],
    },
    spreadsheetSelectedRowIndex: undefined,
    dataList: {
      inDefCommonFlagType: [],
      layoutDerivationReasonType: [],
    },
    displayColumn: displayColumn,
  };
